import React, { useEffect, useState, useMemo } from 'react';
import { withRouter } from "react-router-dom";
import Api from '../Services/Api';
import { getGameTypeName, getDateFormat } from '../Services/Custom';
import moment from 'moment';
import DataTable from 'react-data-table-component';
const Cusrrency = process.env.REACT_APP_CURRENCY_SYMBOL;

export const BidUpdateReport = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    let dfltDate = getDateFormat();
    const [searchDate, setSearchDate] = useState(dfltDate);
    const [isReset, setIsReset] = useState(0);
    const [search, setSearch] = useState('');

    const columns = useMemo(() => [
        {
            name: 'Date/Time',
            selector: row => moment(row.createdAt).format('DD MMM, YY hh:mm A'),
            sortable: true,
        },
        {
            name: 'Updated By (Admin)',
            selector: row => row.admin ? row.admin.firstname : '-',
        },
        {
            name: 'User Name',
            selector: row => row.user ? row.user.firstname : '-',
        },
        {
            name: 'Mobile',
            selector: row => row.user ? row.user.mobile_no : '-',
        },
        {
            name: 'Market',
            selector: row => row.market ? row.market.name : '-',
        },
        {
            name: 'Game Type',
            selector: row => getGameTypeName(row.game_type_id)
        },
        {
            name: 'Old Bid',
            selector: row => (row.prev_panna_2) ? row.prev_panna_1 + '-' + row.prev_panna_2 : row.prev_panna_1
        },
        {
            name: 'New Bid',
            selector: row => (row.new_panna_2) ? row.new_panna_1 + '-' + row.new_panna_2 : row.new_panna_1
        },
        {
            name: 'Amount',
            selector: row => row.amount + Cusrrency
        }
    ]);

    const bidReportData = async page => {
        setLoading(true);
        var sendd = { page: page, size: perPage, date: searchDate, search: search };
        const response = await Api.post('report/bid-update-logs', sendd);
        if (response.data.status === 1) {
            setData(response.data.data.docs);
            setTotalRows(response.data.data.totalDocs);
        } else {
            setData([]);
            setTotalRows(0);
        }
        setLoading(false);
    };

    const handlePageChange = page => {
        bidReportData(page);
    };
    const handlePerRowsChange = async (newPerPage, page) => {
        setLoading(true);
        var sendd = { page: page, size: newPerPage, date: searchDate, search: search };
        const response = await Api.post('report/bid-update-logs', sendd)
        if (response.data.status === 1) {
            setData(response.data.data.docs);
            setPerPage(newPerPage);
        }
        setLoading(false);
    };
    const handleChangeDateSearch = (e) => {
        setSearchDate(e.target.value);
    };
    const handleChangeSearch = (e) => {
        setSearch(e.target.value);
    };

    const handleFilter = () => {
        setIsReset(!isReset);
    };
    function handleResetFilter() {
        setSearchDate('');
        setSearch('');
        setIsReset(0);
    }

    useEffect(() => {
        bidReportData(1);
    }, [isReset]);

    return (
        <>
            <section className="main-content userlist_main_sec">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="header-text">
                                            <h4 className="card-title mb-4">Bid Update Logs</h4>
                                        </div>
                                        <div className="border border-primary p-3 mb-4">
                                            <h4 className="card-title mb-4">Filter :</h4>
                                            <div className="row mb-2">
                                                <div className="col-lg-3 col-md-3">
                                                    <input type="date" className="form-control" placeholder="Date" value={searchDate} onChange={(e) => handleChangeDateSearch(e)} />
                                                </div>
                                                <div className="col-lg-3 col-md-3">
                                                    <input type="text" className="form-control" value={search} onChange={(e) => handleChangeSearch(e)} placeholder="Search By Name/Mobile" />
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <button type="button" className="btn float-end btn-outline-secondary mr-4 btn-sm btn-rounded waves-effect waves-light" onClick={() => handleResetFilter()}>Reset</button>
                                                    <button type="button" className="btn float-end btn-outline-success mr-4 btn-sm btn-rounded waves-effect waves-light" onClick={() => handleFilter()}>Filter</button>
                                                </div>
                                            </div>
                                        </div>
                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            progressPending={loading}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onChangePage={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default withRouter(BidUpdateReport);
